import { Component } from 'react';
import deepMerge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import store from '../configureStore';
import * as orderActions from '../actions/orders';
import productActions from '../actions/products';
import * as settingsActions from '../actions/settings';
import { getLocation, isDifferentTimezones, isScheduled } from '../utilities/helperUtility';
import { convertRegionToISOCode } from '../utilities/localizationUtility';

export default class ComponentWidgetContainer extends Component {
  constructor(props) {
    super(props);

    const {
      apiVerbose,
      bookingFields,
      defaultSetting,
      defaultTranslation,
      depositSettings,
      exceededBookingsLimit,
      exceededTrialPlan,
      multipleAppointmentsEnabled,
      product,
      quantityRange,
      reservationEnabled,
      rescheduleBookingResources,
      rescheduleBookingLocation,
      rescheduleBookingVariants,
      securityBondSettings,
      selectedLocationId,
      selectedLocation,
      selectedStart,
      brandingVisualized,
      settings,
    } = props;
    const { locations, resources, variants } = product;
    const region = settings?.region ? convertRegionToISOCode(settings.region) : 'en';

    this.location = getLocation(locations, settings.setting, {
      locationId: rescheduleBookingLocation || selectedLocationId,
      locationName: selectedLocation,
      useDefault: isScheduled(product.profile) && isDifferentTimezones(locations)
    });

    const newStyle = window.xprops && window.xprops.data && window.xprops.data.style;
    this.processedSettings = newStyle ? deepMerge(settings, { style: newStyle }) : settings;

    store.dispatch(
      settingsActions.setConfiguration({
        ...this.processedSettings,
        apiVerbose,
        bookingFields,
        defaultSetting,
        defaultTranslation,
        depositSettings,
        brandingVisualized,
        exceededBookingsLimit,
        exceededTrialPlan,
        multipleAppointmentsEnabled,
        product,
        quantityRange,
        rescheduleBookingLocation,
        rescheduleBookingVariants,
        reservationEnabled,
        securityBondSettings,
        urlParams: { start: selectedStart },
      }),
    );

    if (!isEmpty(this.location)) {
      store.dispatch(orderActions.setSelectedLocation(this.location));
      store.dispatch(settingsActions.setTimeZone(this.location.timezone));
    }

    if (!isEmpty(rescheduleBookingResources)) {
      const bookingResource = resources.find((resource) => resource.id === rescheduleBookingResources[0]);

      if (bookingResource) {
        store.dispatch(orderActions.setSelectedResource(bookingResource));
      }
    }

    store.dispatch(productActions.fetchProduct(product));

    if (variants.length > 0) {
      store.dispatch(
        orderActions.setVariantsQuantity(
          `${this.variantId()}_quantity`,
          this.variantQuantity(),
          { singleVariant: true },
        ),
      );
    }

    window.changeApiVerbose = (value) => {
      store.dispatch(settingsActions.setApiVerbose(value));
    };
  }

  componentDidMount() {
    if (window.xprops && window.xprops.onInit) {
      window.xprops.onInit(this.processedSettings.setting);
    }
  }

  variantId() {
    const { product: { variants = [] }, variantExternalId, rescheduleBookingVariants } = this.props;
    const variantsWithExternalId = variants.map((v) => v.external_id);

    if (!variants.length) {
      return null;
    }

    if (!isEmpty(rescheduleBookingVariants)) {
      return rescheduleBookingVariants[0].variant_id;
    }

    if (!variantsWithExternalId.includes(Number(variantExternalId))) {
      return variants[0].external_id;
    }

    return Number(variantExternalId);
  }

  variantQuantity() {
    const { rescheduleBookingVariants } = this.props;
    return (!isEmpty(rescheduleBookingVariants)) ? rescheduleBookingVariants[0].quantity : 1;
  }
}
